import { useIntl } from 'react-intl';

import classnames from 'classnames';
import Icon from '@ant-design/icons';

import { UNAUTHORIZED_ERROR_MSG } from 'constants/common';
import { META_CATALOG_NAME } from 'constants/pixels';
import { useModal } from 'contexts/modalProvider.context';
import { sendSegment } from 'utils/segment';
import { getAppStoreAccess } from 'utils/permissions/permissions-apply';

import BRButton from 'components/BRButton/BRButton';
import AddEditPixelIDModal from '../AddEditPixelIDModal.js/AddEditPixelIDModal';

import './SectionCard.less';

const SectionCard = ({
  classname,
  title,
  subtitle,
  iconClassName,
  icon,
  isActivated,
  subIcon,
  isBtnDisabled = false,
  name,
  apiKey,
  setBusinessInfo,
  businessInfo,
  integratedPixelData,
  cardBtnLabel = '',
  ...props
}) => {
  const intl = useIntl();
  const { openModal } = useModal();

  const { DIM_INSTALL_BUTTON, DIM_MANAGE_BUTTON } = getAppStoreAccess(
    businessInfo?.userSllrPermissions
  );

  const handleOpenSection = async () => {
    if (name === META_CATALOG_NAME) {
      await sendSegment('meta_catalogue_connect');
    }
    openModal(AddEditPixelIDModal, {
      apiKey,
      subtitle,
      setBusinessInfo,
      businessInfo,
      isActivated,
      name,
      intl,
      iconClassName,
      icon,
      subIcon,
      integratedPixelData,
      ...props
    });
  };

  return (
    <div
      className={classnames('br-section-card', {
        [classname]: classname
      })}
      key={name}
    >
      <div className="br-section-card__content">
        <span
          className={classnames('br-section-card__icon', {
            [iconClassName]: iconClassName
          })}
        >
          <Icon component={icon} />
          {subIcon && <Icon component={subIcon} />}
        </span>
        <div className="br-section-card__right-content">
          <div className="br-section-card__right-content__text">
            <span className="heading">
              {title}
              {isActivated && (
                <span className="br-section-card__right-content__text__tag caption-lg">
                  {intl.formatMessage({ id: 'pixels.added' })}
                </span>
              )}
            </span>
            <span className="br-section-card__right-content__text__subtitle">
              {subtitle}
            </span>
          </div>
          {!isActivated ? (
            <BRButton
              label={
                cardBtnLabel || intl.formatMessage({ id: 'pixels.install' })
              }
              className={'button-md'}
              onClick={handleOpenSection}
              disabled={isBtnDisabled || DIM_INSTALL_BUTTON}
              loading={isBtnDisabled}
              type="outline"
              tooltipTitle={DIM_INSTALL_BUTTON && UNAUTHORIZED_ERROR_MSG}
            />
          ) : (
            <BRButton
              label={intl.formatMessage({
                id: 'pixels.manage'
              })}
              type="primary"
              onClick={handleOpenSection}
              className="button-md"
              disabled={DIM_MANAGE_BUTTON}
              tooltipTitle={DIM_MANAGE_BUTTON && UNAUTHORIZED_ERROR_MSG}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionCard;
